/* ============================================================
   DOGVANTURE CARD UNIFORMITY - v14
   ------------------------------------------------------------
   20.10.2026:
   - Quick-Add-Buttons entfernt
   - KEIN CTA-Button mehr (Bild & Titel sind bereits Link zur PDP)
   - Sterne/Ratings nur auf PDP
   - Karte: Bild + Titel + Fit-Zeile + Preis. Fertig.
   ============================================================ */
(() => {
  const VERSION = '14';
  const norm = (s = '') => s.replace(/\s+/g, ' ').trim();

  function productFit(title) {
    const t = title.toLowerCase();
    if (t.includes('würfel soft')) return 'Weich · ca. 1 cm';
    if (t.includes('würfel mini')) return 'Fest · ca. 1 cm';
    if (t.includes('würfel maxi')) return 'Fest · ca. 1,5 cm';
    if (t.includes('fleischstreifen') || t.includes('streifen') || t.includes('stick')) return 'Teilbar · ca. 11 cm';
    if (t.includes('lunge') || t.includes('pansen')) return 'Naturbelassen · ca. 10–15 cm';
    if (t.includes('kauartikel') || t.includes('kausnack') || t.includes('rehhaut')
      || t.includes('hirschhaut') || t.includes('wildschweinohr') || t.includes('haut mit fell')
      || t.includes('entenhals') || t.includes('entenhälse') || t.includes('lachshaut')) {
      return 'Kauartikel · für längeres Kauen';
    }
    return '';
  }

  function removeRatingsFromCard(card) {
    card.querySelectorAll('.rating, .rating-text, .rating-count, .dv-rating-row, .jdgm-widget, .jdgm-preview-badge, .jdgm-prev-badge').forEach(el => el.remove());
  }

  function removeQuickAdd(card) {
    card.querySelectorAll('.quick-add, quick-add-modal, quick-add-bulk').forEach(el => el.remove());
  }

  function enhanceCard(card) {
    if (card.dataset.dvEnhanced === VERSION) return;
    const titleLink = card.querySelector('.card__heading a');
    const info = card.querySelector('.card-information');
    if (!titleLink || !info) return;
    const title = norm(titleLink.textContent);
    const fit = productFit(title);

    info.querySelectorAll('.dv-badge-row, .dv-product-fit, .dv-card-cta').forEach(el => el.remove());
    [...info.children].forEach(el => {
      if (el.classList?.contains('dv-highlight-badge')) el.remove();
    });

    removeRatingsFromCard(card);
    removeQuickAdd(card);

    if (fit) {
      const fitEl = document.createElement('div');
      fitEl.className = 'dv-product-fit';
      fitEl.textContent = fit;
      info.prepend(fitEl);
    }

    card.dataset.dvEnhanced = VERSION;
  }

  function processAll(root = document) {
    root.querySelectorAll('.product-card-wrapper').forEach(enhanceCard);
  }

  function watchCollections() {
    const targets = [
      ...document.querySelectorAll('collection-component'),
      ...document.querySelectorAll('.product-grid'),
      ...document.querySelectorAll('[class*="featured-collection"]'),
      ...document.querySelectorAll('slider-component'),
    ];
    if (!targets.length) {
      const main = document.querySelector('main');
      if (main) targets.push(main);
    }
    let queued = false;
    const scheduled = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; processAll(); });
    };
    const observer = new MutationObserver(scheduled);
    targets.forEach(target => observer.observe(target, { childList: true, subtree: true }));
  }

  function init() {
    processAll();
    watchCollections();
    document.addEventListener('shopify:section:load', event => processAll(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
